export default "__VITE_ASSET__DhyzHQah__"